<script>
export default {
    name: "standards-search",
    methods: {
        clear() {
            this.$store.commit("standardsSearchTerm", "");
            this.focusOnSearch();
        },
        toggleWithdrawn() {
            this.$store.commit(
                "showWithdrawn",
                !this.$store.getters.showWithdrawn
            );
            this.focusOnSearch();
        },
        focusOnSearch() {
            let input = document.getElementById("standards-search-input");
            input.focus();
        }
    },
    computed: {
        withdrawnVerb() {
            return this.$store.getters.showWithdrawn ? "Hide" : "Show";
        },
        showClearButton() {
            return this.standardsSearchTerm.length > 0;
        },
        standardsSearchTerm: {
            get() {
                return this.$store.getters.standardsSearchTerm;
            },
            set(val) {
                this.$store.commit("standardsSearchTerm", val);
            }
        }
    },
    mounted() {
        var urlParams = new URLSearchParams(window.location.search);
        var q = urlParams.get('q');
        if (q) {
            this.$store.commit("standardsSearchTerm", q);
        }

        this.focusOnSearch();
    }
};
</script>

<template>
    <div class="content beige mb-8">
        <p class="meta">Tip: Keep typing! “2011” → “2011*” will provide fewer results</p>
        <div class="flex">
            <div class="input flex-1">
                <input
                    type="search"
                    class="search"
                    placeholder="Start typing to refine results"
                    v-model="standardsSearchTerm"
                    id="standards-search-input"
                >
            </div>
            <transition name="fade">
                <button
                    @click="clear"
                    v-if="showClearButton"
                    class="appearance-none btn btn-white ml-4 h-10 -mt-1"
                >Clear</button>
            </transition>
        </div>
        <div>
            <a href="#" @click="toggleWithdrawn" class="btn btn-white">{{ withdrawnVerb }} Withdrawn</a>
        </div>
    </div>
</template>
